import type { FaireProductEntity } from "../../entity_types/product";

export const p_rhktyf7h9r: FaireProductEntity = {
  token: "p_rhktyf7h9r",
  type: "product",
  name: "Alligator Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/298ea2f371c5f93d01082511ecf38ba2b320e0ba03a91cd936797e023ee77b70.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b1455aa1f8128b493ba7bd0c72ee3586aa93d50b501a0ef4d25edd2f99ac21e.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:14.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
